import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import CustomModal from "@/components/CustomModal";
import { StyledFlex, StyledSubTableContainer } from "@/common/styles";
import RulesCriteriaLocksPermitsForm from "@/pages/Security/Sections/StaffGroupForms/RulesCriteriaLocksPermitsForm";
import {
  fetchSecurityRulesCriteria,
  fetchSecurityRuleCriteriaById,
  createSecurityRuleCriteria,
  updateSecurityRuleCriteria,
  deleteSecurityRuleCriteria,
} from "@/apis/security/securityRulesCriteriaApi";
import { clearCurrentCriteria } from "@/slices/securityRulesCriteriaSlice";
import { fetchGlobalCriteria } from "@/apis/security/globalCriteriaApi";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import { setBookings } from "@/slices/bookingsSlice";
import { isNonEmptyVariable } from "@/util/common_function";
import { v4 as uuidV4 } from "uuid";
import _ from "lodash";
import useDialog from "@/hooks/useDialog";

const UserInfoCriteriaRulesControlling = ({ staffGroupsId, bookingsFieldsEnabled = true }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const tableRef = useRef();
  const { showDialog } = useDialog();

  // const list = useSelector((s) => s.securityRulesCriteria.list) || [];
  // const list = useSelector((s) => s.staff.securityRulesCriteria) || [];
  const [list, setList] = useState([])
  const { bookings } = useSelector((s) => s?.bookings);

  const loadingList = useSelector((s) => s.securityRulesCriteria.listLoading);
  const current = useSelector((s) => s.securityRulesCriteria.current);
  const currentLoading = useSelector((s) => s.securityRulesCriteria.currentLoading);
  const saving = useSelector((s) => s.securityRulesCriteria.saving);
  const deleting = useSelector((s) => s.securityRulesCriteria.deleting);
  const globalCriteria = useSelector((s) => s.globalCriteria.list) || [];

  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState("add");

  const criteriaMap = useMemo(
    () => Object.fromEntries(globalCriteria.map(c => [c.globalCriteriaID, c.criteriaName])),
    [globalCriteria]
  );
  const data = useMemo(
    () => list.map(row => ({
      ...row,
      criteriaName: criteriaMap[row.globalCriteriaID] || row.globalCriteriaID,
    })),
    [list, criteriaMap]
  );

  useEffect(() => {

    // dispatch(fetchSecurityRulesCriteria());
    // dispatch(clearCurrentCriteria());
    setSelectedRow(null);

    // dispatch(fetchGlobalCriteria());
  }, [dispatch]);
  useEffect(() => {
    if (isNonEmptyVariable(bookings?.securityRulesCriteria)) {
      let allRules = bookings?.securityRulesCriteria?.map((e, i) => {
        return {
          ...e,
          uuid: uuidV4(),
        }
      })
      console.log(allRules, "allRules")
      if (allRules?.length) {
        setList([...allRules])
      }
      else{
        setList([])
      }
    }
  }, [bookings]);
  const onRowClick = (row, index) => {
    setSelectedRow(row);
    if(index !== null && index !== undefined) {
      openEdit();
    }
  };

  const openAdd = () => {
    form.resetFields();
    dispatch(clearCurrentCriteria());
    setMode("add");
    setSelectedRow(null);
    setModalOpen(true);
  };

  const openEdit = () => {
    if (!selectedRow) return;
    form.resetFields();
    dispatch(clearCurrentCriteria());
    dispatch(fetchSecurityRuleCriteriaById(selectedRow.securityRulesCriteriaID));
    setMode("edit");
    setModalOpen(true);
  };

   const openDelete = () => {
    if (!selectedRow) return;
    // setDeleteOpen(true);
    showDialog("confirm", {
      title: "Are you sure you want to delete this record?",
      onConfirm: () => confirmDelete(),
      // onCancel: () => { setIsLoading(false) }
    });
  };
  const confirmDelete = () => {
    if (!selectedRow) return;
    dispatch(deleteSecurityRuleCriteria(selectedRow.securityRulesCriteriaID))
    let newList = _.cloneDeep(list)
    if (newList?.length) {
      newList = newList.filter((e, i) => {
        if (e.uuid != selectedRow?.uuid) {
          return e
        }
      })
      console.log({ newList })
      dispatch(
        setBookings({
          securityRulesCriteria: [...newList],
        })
      );
    }
    setSelectedRow(null);
  };

  const closeModal = () => {
    dispatch(clearCurrentCriteria());
    setModalOpen(false);
  };

  const handleSave = () => form.submit();

  const onFinish = values => {
    const payload = {
      ...values,
      dateAdded: values.dateAdded?.format("MM/DD/YYYY"),
      timeAdded: values.timeAdded?.format("HH:mm"),
      staffId: bookings?.staffId,
      ruleActive: ruleActive ? "true" : "false"
    };
    let newList = _.cloneDeep(list)
        // console.log({ payload })
        if (mode == "edit") {
          console.log({ selectedRow })
          if (newList?.length) {
            newList = newList.map((e, i) => {
              if (e.uuid == selectedRow?.uuid) {
                console.log({ ...e, ...payload }, "newList")
                return { ...e, ...payload }
              }
              return e
            })
            console.log({ newList })
          } 
        }
  if (mode == "add") {
      if (newList?.length == 0) {
        newList.push(payload)
        // setList([payload])
      } else {
        console.log({payload})
        newList=[...newList,payload]
        // setList([...list, payload])
      }
    }
    console.log({list})
        dispatch(
          setBookings({
            securityRulesCriteria: [...newList],
          })
        );

          closeModal();
  };

  const headers = [
    { key: "criteriaName", text: "Criteria Name" },
    { key: "startingPoint", text: "Starting Point" },
    { key: "comment", text: "Comment" },
    { key: "allowSetting", text: "Allow" },
    { key: "denySetting", text: "Deny" },
  ];
  const handleCancel = () => {
    setSelectedRow(null)
    tableRef.current.resetAll()
  }
  return (
    <>
      <StyledSubTableContainer marginTop="25px">
        <StyledFlex justify="space-between" align="center">
          <h2>Criteria rules controlling access to data</h2>
          <StyledFlex gap="10px" marginBottom="5px" justify="end">
            <Button onClick={openAdd} loading={saving} disabled={!bookingsFieldsEnabled}>Add</Button>
            <Button onClick={openEdit} disabled={!selectedRow||!bookingsFieldsEnabled} loading={currentLoading}>Details</Button>
            <Button onClick={openDelete} disabled={!selectedRow || !bookingsFieldsEnabled} loading={deleting}>Delete</Button>
            <Button onClick={handleCancel} disabled={!selectedRow||!bookingsFieldsEnabled} loading={currentLoading}>Cancel</Button>

          </StyledFlex>
        </StyledFlex>

        <Spin spinning={loadingList}>
          <DataTable
            headers={headers}
            data={data}
            ref={tableRef}
            rowUniqueId="uuid"
            onRowClick={onRowClick}
            allowTableSorting
            autoResetSelection={false}
            selected={selectedRow === null}
          />
        </Spin>
      </StyledSubTableContainer>

      {isModalOpen && (
        <CustomModal
          size="lg"
          header={mode === "add" ? "Add Criteria Rule" : "Modify Criteria Rule"}
          show={isModalOpen}
          onHide={closeModal}
          onSaveClick={handleSave}
          confirmLoading={saving}
          backdrop={false}
          isDisabled={!bookingsFieldsEnabled}
        >
          <RulesCriteriaLocksPermitsForm
            form={form}
            initialValues={mode === "edit" ? selectedRow : {}}
            onFinish={onFinish}
            disabled={currentLoading}
          />
        </CustomModal>
      )}
    </>
  );
};

export default UserInfoCriteriaRulesControlling;
